import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const basePath = '/dealer/subdealer';

@Injectable({
  providedIn: 'root'
})

export class DealerSubdealerService {
  constructor(private http: HttpClient) { }

  // Deletes a subdealer of the current dealer when all conditions are met
  deleteSubdealer(subdealer_id: number) {
      return this.http.delete(`${basePath}/${subdealer_id}`);
    }
}
